import { gql } from '@apollo/client';

export const CREATE_FOUND_ANIMAL = gql`
  mutation CreateFoundAnimal($input: CreateFoundAnimalInput!) {
    createFoundAnimal(input: $input) {
      _id
      contactName
      contactPhone
      contactEmail
      location {
        type
        coordinates
      }
      animalName
      animalType
      animalImageUrl
      breed
      colorMarkings
      dateFound
      sex
      foundNear
      estimatedWeight
      createdAt
      updatedAt
      language
    }
  }
`;

export const UPDATE_FOUND_ANIMAL = gql`
  mutation UpdateFoundAnimal($_id: ID!, $input: UpdateFoundAnimalInput!) {
    updateFoundAnimal(_id: $_id, input: $input) {
      _id
      contactName
      contactPhone
      contactEmail
      location {
        type
        coordinates
      }
      animalName
      animalType
      animalImageUrl
      breed
      colorMarkings
      dateFound
      sex
      foundNear
      estimatedWeight
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_FOUND_ANIMAL = gql`
  mutation DeleteFoundAnimal($_id: ID!) {
    deleteFoundAnimal(_id: $_id) {
      _id
    }
  }
`;

export const UPDATE_FOUND_REUNITED_STATUS = gql`
  mutation UpdateFoundReunitedStatus($_id: ID!, $reunited: Boolean!) {
    updateFoundReunitedStatus(_id: $_id, reunited: $reunited) {
      _id
      reunited
      updatedAt
    }
  }
`;
